<div 
  class="card" 
  tabindex="0" 
  role="button" 
  [class.heightAuto]="heightAuto"
  [attr.aria-label]="'Card for ' + card.artName"
  >

  <div 
  class="user-card-image pointer relative" 
  [ngClass]="
    isSelectionEnabled && showValidationMessage && card.artistId == artistId ? 'own-art' :
    isSelectionEnabled && showValidationMessage && card.subscribed ? 'already-subscribed' :
    isSelectionEnabled && showValidationMessage && !card.price ? 'price-warning' : ''
    " 
    (click)="onCardClick()">

    <canvas #canvas class="card-canvas"  height="180"></canvas>
    <div *ngIf="role === 'ARTIST' && !card.price" class="absolute noDataAvail" title="Add the artwork price.">
      <img class="ques-photo" src="assets/images/question-mark.svg" alt="No data"/>
    </div>

  </div>
  
  <div class="card-info flex flex-col" *ngIf="showArtist">
    <div class="card-user cursor-pointer" (click)="redirectToProfile(card)" >
      <div class="artist-profile">
        <img
          [src]="card.profilePic"
          onerror="this.src = 'assets/images/dummyP.jpg'"
          alt="User image"
          class="user-image"
          loading="lazy"
        />
      </div>
      <span>{{ card.artistName || '' }}</span>
    </div>
  </div>
  <button
    *ngIf="showLike"
    class="like-button flex items-center justify-center"
    (click)="toggleLike($event)"
    [attr.aria-label]="'Toggle like for ' + card.artName"
  >
    <img 
    loading="lazy"
      [src]="liked ? 'assets/images/fav-red.svg' : 'assets/images/fav-black.svg'" 
      alt="Like icon" 
    />
  </button>
  
  <div class="toggle-selection" 
  [title]="
  isSelectionEnabled && card.price && !card.subscribed && card.artistId !== artistId
    ? 'Select here to subscribe'
    : ''
  "
    *ngIf="isSelectionEnabled"
    [class.is-selecting]="userIsSelecting && !(!card.price || (showValidationMessage && card.subscribed) || this.card.artistId == this.artistId)"
    [attr.data-order]="selectOrder || ''"
    >
    <input
      class="toggle-switch"
      #selectInput
      [checked]="selectOrder"
      (click)="select($event)"
      type="checkbox">
  </div>
</div>

<app-guest-login *ngIf="isLoginPopupOpen" (close)="isLoginPopupOpen = false"></app-guest-login>
